import { type PortableTextMarkComponentProps } from '@portabletext/react'

import { type SanityFrameBuilderBlockLink } from '@frame-builder/data/sanity/queries/types/content'

import BaseLink from '@components/link'

type LinkValue = SanityFrameBuilderBlockLink

const Link = ({
  value,
  children,
}: PortableTextMarkComponentProps<LinkValue>) => {
  if (!value) {
    return null
  }

  return <BaseLink link={value}>{children}</BaseLink>
}

export default Link
